(() => {
  'use strict';

  if (window.ChowHQImportantNoticesLoaded) return;
  window.ChowHQImportantNoticesLoaded = true;

  const checkoutSelector = [
    '#cart-checkout',
    '#cart-sidebar-checkout',
    '.button-checkout',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[data-cart-checkout]',
    'a[href^="/checkout"]'
  ].join(',');

  const noticeMarkup = `
    <aside class="chowhq-checkout-notice" aria-label="Important allergy and delivery information">
      <strong class="chowhq-checkout-notice__title">Before checkout</strong>
      <p class="chowhq-checkout-notice__copy chowhq-checkout-notice__copy--full">
        Please check product ingredients and allergen information before ordering. Aramex is a lower-cost option and delivery times may vary; Australia Post is available if you prefer its service network.
      </p>
      <a class="chowhq-checkout-notice__link chowhq-checkout-notice__link--full" href="/pages/shipping-delivery">View delivery information</a>
      <p class="chowhq-checkout-notice__copy chowhq-checkout-notice__copy--mobile">
        Check ingredients for allergens. Aramex delivery times may vary.
        <a class="chowhq-checkout-notice__link" href="/pages/shipping-delivery">Details</a>
      </p>
    </aside>
  `;

  function createNotice() {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = noticeMarkup.trim();
    return wrapper.firstElementChild;
  }

  function addNotice(checkoutControl) {
    if (!(checkoutControl instanceof Element)) return;
    if (checkoutControl.dataset.chowhqNoticeTargeted === 'true') return;
    if (checkoutControl.closest('.shopify-payment-button')) return;

    const existingNotice = checkoutControl.previousElementSibling;
    if (existingNotice?.classList.contains('chowhq-checkout-notice')) {
      checkoutControl.dataset.chowhqNoticeTargeted = 'true';
      return;
    }

    checkoutControl.insertAdjacentElement('beforebegin', createNotice());
    checkoutControl.dataset.chowhqNoticeTargeted = 'true';
  }

  function installNotices() {
    document.querySelectorAll(checkoutSelector).forEach(addNotice);
  }

  let updateQueued = false;

  function scheduleInstall() {
    if (updateQueued) return;
    updateQueued = true;

    requestAnimationFrame(() => {
      updateQueued = false;
      installNotices();
    });
  }

  const observer = new MutationObserver(scheduleInstall);

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
    installNotices();
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true });
      installNotices();
    }, { once: true });
  }

  document.addEventListener('shopify:section:load', scheduleInstall);
})();
